import {Actors} from './Actors';
export default Actors;